import { FeatureText, PageHeader, IPageHeaderProps } from '@fcamna/react-library';
import { HeadingLevel, HeadingSize } from '../components/Header/Header';
import { TSectionAemProp } from '../model/AemDataProps';
import { htmlReactParser } from '../utils/htmlReactParser';

type SectionProps = {
  aemSectionProps?: TSectionAemProp;
  headingLevel?: HeadingLevel;
  size?: HeadingSize;
  className?: string;
} & Partial<IPageHeaderProps>;
/* Use for any kind of section or header component. aemSectionProp can be directly passed
 * IFeatureTextProps to render the section. */
export function Section({
  aemSectionProps,
  headingLevel,
  size,
  className,
  ...props
}: SectionProps) {
  // IPageHeaderProps, if specified will take precedence as they are over-writing defaults
  const defaultTitleProp = {
    title: htmlReactParser(aemSectionProps?.heading ?? ''),
    headingLevel: headingLevel ?? 'h2',
    size: size ?? 'large',
  };
  const defaultDescription = aemSectionProps?.text ?? '';

  return (
    <PageHeader
      titleProp={{ ...defaultTitleProp }}
      description={htmlReactParser(defaultDescription)}
      className={className ?? ''}
      bottomStroke={false}
      hideBackground
      {...props}
    />
  );
}
